import { Component, ComponentFactoryResolver, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SocialUser } from 'angularx-social-login';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginService } from '../../service/login.service';
import { NotifierService } from 'angular-notifier';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { User } from 'src/app/models/user';
import { UserService } from 'src/app/service/user.service';
import { Globals } from 'src/app/service/global';
import { UtilityService } from 'src/app/service/utility.service';
import { AttendeeService } from 'src/app/service/attendee.service';
import { MeetingService } from 'src/app/service/meeting.service';
import moment from 'moment';
import 'moment-timezone';
import { stringify } from 'querystring';
import { SettingsService } from 'src/app/service/settings-service';
import { HttpHeaders } from '@angular/common/http';
import { Console } from 'console';
import * as Forge from 'node-forge';
const forge = require('node-forge');


@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {
  @ViewChild('formDirectiveInd')
  private formDirectiveInd!: NgForm;
  @ViewChild('formDirectiveGroup')
  private formDirectiveGroup!: NgForm
  //UI Team variable declaration
  showValidator = false;
  isSubmitted = false;
  showHelpVideo: boolean = false;

  forgetPasswordSubmitted = false

  //login variable
  @Output() loginPage = new EventEmitter();

  loginForm !: UntypedFormGroup;

  forgetPassword !: UntypedFormGroup;

  submitted = false;
  loading = false;
  error = "";
  returnUrl !: string;
  showLoadingIndicator = false;
  user !: SocialUser;
  loggedIn !: boolean;
  tokenId: string = "";
  userId: string = "";
  userName: string = "";
  validate = false
  showSignUp = false;
  showSignIn = true;
  individualShow = true;
  groupShow = false;
  secQuesValues: any = [];
  companyExist: any = [];
  //forget password div
  showForgetPasswordDiv = false
  showSecurityQuestions = false

  newUserDetails!: any;
  meetingId!: any;
  adminDetails: any;
  private readonly notifier!: NotifierService;
  currentUser: User = new User;
  taskStatusList: any;
  timezone: any;
  isGuestUser: string = "";
  reqJson: any;
  decUserDetails: User = new User;
  loginKey: any;
  userDetails: any;
  forgotPasswordJson: any;
  questions: any = [];
  errorMessage?: string;
  docMeetTypeList: any;
  open: any;
  publicKey: any;
  passwordPolicyMap: any;
  constructor(private authenticationService: AuthenticationService, private activatedroute: ActivatedRoute, private notifierService: NotifierService, private formBuilder: UntypedFormBuilder, private loginService: LoginService, private spinner: NgxSpinnerService, private router: Router, private authService: AuthenticationService, private userService: UserService, private utilityService: UtilityService, private meetingService: MeetingService, private attendeeService: AttendeeService, private globals: Globals, private settings: SettingsService) {
    this.notifier = notifierService;
    this.timezone = moment.tz.guess();
    this.globals.resetGlobals();

    this.activatedroute.queryParams.subscribe(
      (params: any) => {
        ////consolee.log('testing params=',params['userName']);
        // this.open = params['open'];
        this.open = params['open'];
        this.userName = params['userName'];
        this.meetingId = params['meetingId'];
        this.isGuestUser = params['isGuest'];
        if (this.isGuestUser != 'undefined' && this.isGuestUser == "1") {
          localStorage.setItem('isGuest', this.isGuestUser);
        }
        this.loginKey = params['loginKey'];
        //
        if (this.userName != 'undefined') {
          this.reqJson = { "userName": params['userName'], "meetingId": params['meetingId'] };
          this.loginService.getDecryptedDetails(this.reqJson).subscribe((data: any) => {
            this.decUserDetails = data.body;
            this.loginForm.controls['userName'].setValue(this.decUserDetails.loginName);
            this.meetingId = this.decUserDetails.meetingId;

            if ((this.isGuestUser != 'undefined' && this.isGuestUser == "1") || this.loginKey != undefined) {

              this.onLoginApp();
            }

            ////consolee.log('decUserDetails',this.decUserDetails);
          })
        }
      });
  }


  showSignUpDiv(signUp: any) {
    this.showSignUp = signUp;
    this.showSignIn = false;
    this.userRegForm.reset();
    this.forgetPassword.reset();
    this.loginForm.reset()
    this.groupUserRegForm.reset();
    this.isSubmitted = false
    this.showValidator = false;
  }

  showSignInDiv(signIn: any) {
    this.showSignIn = signIn;
    this.showSignUp = false
    this.showForgetPasswordDiv = false
    this.userRegForm.reset();
    this.forgetPassword.reset();
    this.loginForm.reset()
    this.submitted = false
    this.isSubmitted = false
    this.groupUserRegForm.reset();
    this.showValidator = false;
  }

  showIndividual(individual: any) {
    let individualForm = <HTMLElement>document.getElementById('individual-form');
    individualForm.setAttribute('style', 'display : block')
    let groupForm = <HTMLElement>document.getElementById('group-form');
    groupForm.setAttribute('style', 'display : none')
    this.formDirectiveInd.resetForm();
    this.isSubmitted = false
  }


  createEmpFormGroup() {
    return this.formBuilder.group({
      quesCode: ['', [Validators.required]],
      quesAnswer: ['', [Validators.required]],
      question: []
    })
  }
  showGroup(group: any) {
    let individualForm = <HTMLElement>document.getElementById('individual-form');
    individualForm.setAttribute('style', 'display : none')
    let groupForm = <HTMLElement>document.getElementById('group-form');
    groupForm.removeAttribute('style')
    this.formDirectiveGroup.resetForm();
    this.submitted = false
  }

  openLayout(bool: any) {
    this.loginPage.emit(true)
    this.router.navigate(['/dashboard']);
  }

  keyPressNumbers(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  userRegForm = new UntypedFormGroup({
    firstName: new UntypedFormControl('', [Validators.required]),
    lastName: new UntypedFormControl('', [Validators.required]),
    email: new UntypedFormControl('', [Validators.required]),
    phno: new UntypedFormControl(''),
    userId: new UntypedFormControl(''),
    orgCode: new UntypedFormControl(''),
    isAdmin: new UntypedFormControl(''),
    adminEmail: new UntypedFormControl(''),
    adminFullName: new UntypedFormControl(''),
    userType: new UntypedFormControl(''),
    isGuestUser: new UntypedFormControl(''),
    organizationId: new UntypedFormControl(''),
    timeszone: new UntypedFormControl(''),
  });

  groupUserRegForm = new UntypedFormGroup({
    firstName: new UntypedFormControl('', [Validators.required]),
    lastName: new UntypedFormControl('', [Validators.required]),
    email: new UntypedFormControl('', [Validators.required]),
    companyName: new UntypedFormControl(''),
    phno: new UntypedFormControl(''),
    userId: new UntypedFormControl(''),
    orgCode: new UntypedFormControl(''),
    isAdmin: new UntypedFormControl(''),
    adminEmail: new UntypedFormControl(''),
    adminFullName: new UntypedFormControl(''),
    userType: new UntypedFormControl(''),
    isGuestUser: new UntypedFormControl(''),
    organizationId: new UntypedFormControl(''),
    timeszone: new UntypedFormControl(''),
    adminUserId: new UntypedFormControl(''),
    adminLoginName: new UntypedFormControl(''),
  });



  //forget password form
  // forgetPassword = new FormGroup({
  //   userName : new FormControl('',[Validators.required]),
  //   email : new FormControl('',[Validators.required,Validators.email])
  // })

  checkEmailExists(flag: any) {
    var req;
    if (flag == "I") {
      req = this.userRegForm.value
    } else {
      req = this.groupUserRegForm.value
    }

    this.userService.checkEmailExists(req).subscribe((data: any) => {
      this.newUserDetails = data.body;
      ////consolee.log("isExternal"+this.newUserDetails.firstName+","+this.newUserDetails.isValidUser);
      if (this.newUserDetails.isValidUser == "true") {
        if (flag == "I") {
          this.userRegForm.controls['firstName'].setValue(this.newUserDetails.firstName);
          this.userRegForm.controls['lastName'].setValue(this.newUserDetails.lastName);
        } else {
          this.groupUserRegForm.controls['firstName'].setValue(this.newUserDetails.firstName);
          this.groupUserRegForm.controls['lastName'].setValue(this.newUserDetails.lastName);
        }
        if (this.newUserDetails.userIsExternal == 1) {
          this.newUserDetails.isGuestUser = "Y";
          if (this.newUserDetails.userLoginFlag == "1") {
            //send registration email again

          }

        } else {
          this.notifier.show({
            type: 'error',
            message: 'User Already Exists'
          });
          //document.getElementById("emailVal")?.focus()
        }
      }
    });
  }

  createNewUser() {
    this.submitted = true;
    if (this.userRegForm.invalid) {
      //this.submitted = false;
      return;
    }
    this.validate = false;
    this.spinner.show();

    this.userRegForm.controls['timeszone'].setValue(this.timezone);
    this.userRegForm.controls['jobType'].setValue('I');
    this.userService.saveUser(this.userRegForm.value).subscribe((data: any) => {
      var resp = data;
      if (resp.body.errorMessage == null || resp.body.errorMessage == undefined) {
        this.notifier.show({
          type: 'success',
          message: 'Registration is successful. Thank you for registering with Agora. Please check your email.'
        });
        this.spinner.hide();
        this.showSignInDiv(true);
      } else {
        this.notifier.show({
          type: 'error',
          message: resp.body.errorMessage
        });
        this.spinner.hide();
        this.userRegForm.reset();
        //this.showSignInDiv(true);
      }

    }, (error: any) => {
      this.spinner.hide();
      if (error != null) {
        this.notifier.notify("error", JSON.stringify(error['error']));
      }
    });

    //}
  }



  ngOnInit(): void {

    if (this.open == 'signup') {
      this.showSignIn = false;
      this.showSignUp = true;
    }
    this.loginForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required]
    });
    this.userRegForm = this.formBuilder.group({
      // title: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phno: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      acceptTerms: [false, [Validators.requiredTrue]],
      timeszone: this.timezone,
      jobType: 'I',
      // password: ['', [Validators.required, Validators.minLength(6)]],
      // confirmPassword: ['', Validators.required],
      // acceptTerms: [false, Validators.requiredTrue]
    }
      //   {
      //     validator: MustMatch('password', 'confirmPassword')
      // } 
    );
    this.groupUserRegForm = this.formBuilder.group({
      companyName: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phno: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      acceptTerms: [false, [Validators.requiredTrue]],
      orgCode: [""],
      timeszone: this.timezone,
      jobType: 'C',
      adminUserId: [""],
      adminLoginName: [""],
      adminFullName: [""],
      adminEmail: [""],
      // isAdmin:[1]
    });
    this.forgetPassword = this.formBuilder.group({
      userName: ['', Validators.required],
      questionContainer: this.formBuilder.array(
        [this.createEmpFormGroup()],
        [Validators.required, Validators.maxLength(5)]),
      email: ['', [Validators.email]]
    })

  }
  // public checkError = (controlName: string, errorName: string) => {
  //   return this.updateMeetingInfo.controls[controlName].hasError(errorName);
  // }
  get m() {
    return this.forgetPassword.controls;
  }
  get securityQuestions(): UntypedFormArray {
    return this.forgetPassword.get('questionContainer') as UntypedFormArray;
  }

  get userRegControlsVal() {
    // window.alert("caklled") 
    return this.userRegForm.controls;
  }
  get groupRegControlsVal() {
    // window.alert("caklled") 
    return this.groupUserRegForm.controls;
  }
  public signUpCheckError = (controlName: string, errorName: string) => {
    return this.userRegForm.controls[controlName].hasError(errorName)
  }

  public forgetPasswordError = (controlName: string, errorName: string) => {
    return this.forgetPassword.controls[controlName].hasError(errorName)
  }

  showWorkingAlert() {
    this.showForgetPasswordDiv = true
    this.showSignIn = false
  }


  public checkError = (controlName: string, errorName: string) => {
    return this.loginForm.controls[controlName].hasError(errorName);
  }
  get f() { return this.loginForm.controls; }
  onLoginApp() {
    this.submitted = true;
    // stop here if form is invalid
    ////consolee.log('guest user value in ',this.isGuestUser);
    if (this.isGuestUser == undefined || this.isGuestUser == "") {
      if (this.loginKey == undefined && (this.loginForm.invalid || this.f.password.value.trim() == "")) {

        this.showValidator = true
        this.submitted = false;
        return;
      }
    }
    this.loading = true;
    this.spinner.show();
    this.loginService.getKeyPair().subscribe((data: any) => {
      this.publicKey = data.publicKey;
      // this.authService.loginUser(this.f.userName.value, this.f.password.value, this.loginKey)

        this.authService.loginUser(this.encryptWithPublicKey(this.f.userName.value),this.encryptWithPublicKey(this.f.password.value),this.loginKey)
        .subscribe(
          async (data: { body: { [x: string]: string; }; }) => {
            this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
            if (this.currentUser.errorMessage == null || this.currentUser.errorMessage == "") {

              localStorage.setItem("searchValue", "");
              localStorage.setItem("tasksearchValue", "");
              localStorage.setItem('userId', String(this.currentUser.userId));
              localStorage.setItem('userName', this.currentUser.userFullName);
              this.globals.userLoginname = this.currentUser.loginName;
              //UI Team change
              localStorage.setItem('firstName', this.currentUser.firstName)
              localStorage.setItem('isAdmin', this.currentUser.customerId)
              localStorage.setItem('lastName', this.currentUser.lastName)
              localStorage.setItem('loginName', this.currentUser.loginName)
              localStorage.setItem('orgCode', String(this.currentUser.orgCode));
              localStorage.setItem('timeszone', String(this.currentUser.timeszone));
              localStorage.setItem('userShortTzName', String(this.currentUser.userShortTzName));
              localStorage.setItem('userTimezoneIntOffset', String(this.currentUser.userTimezoneIntOffset));
              localStorage.setItem('organizationId', String(this.currentUser.organizationId));
              localStorage.setItem('jobType', String(this.currentUser.jobType));
              localStorage.setItem('userTimezoneOffset', String(this.currentUser.userTimezoneOffset));
              localStorage.setItem('email', String(this.currentUser.email));
              localStorage.setItem('userRightsMap', JSON.stringify(this.currentUser.moduleMap));
              localStorage.setItem('token', this.currentUser.jwtToken);
              localStorage.setItem('encLoginName', this.currentUser.encLoginName);
              localStorage.setItem('loginKey', this.currentUser.loginKey);

              this.startRefreshTokenTimer(localStorage.getItem('token'));
              await this.settings.fetchSettingsListSource("Y").then((result: any) => {
                localStorage.setItem('upcomingMeetConf', this.globals.settingValuesList.UPCOMING_MEETING_CONF);
                localStorage.setItem('pastMeetConf', this.globals.settingValuesList.PAST_MEETING_CONF);
                localStorage.setItem('taskConf', this.globals.settingValuesList.UPCOMING_TASK_CONF);
                this.globals.showTimezone_Date = this.globals.settingValuesList.SHOWTZ_AI;

              });

              await this.userService.fetchReportingUsers("Y", this.currentUser.loginName).then((result: any) => {
                localStorage.setItem("reportingUsers", this.globals.repotingUsers);
              });
              this.showValidator = false
              await this.fetchRoleList();
              await this.fetchTaskStatus();
              await this.fetchDocList();
              this.fetchProjectList();
              this.fetchSpeechEnable().then((result: any) => {
                localStorage.setItem("isSpeechEnabled", result.isSpeechEnabled);
              });
              //
              ////consolee.log("Generated Reponse Body***" + JSON.stringify(this.currentUser));
              this.spinner.hide();
              if (this.authService.getAuthStatus) {
                this.globals.userId = Number(localStorage.getItem("userId"));
                // this.globals.vTimeZoneOffset = localStorage.getItem("userTimezoneOffset");
                this.globals.logType;
                this.globals.orgCode = localStorage.getItem("orgCode");
                this.globals.orgId = localStorage.getItem("organizationId");
                this.globals.userType = localStorage.getItem("jobType");
                if (this.currentUser.userTimezoneIntOffset != null) {
                  //
                  this.globals.vTimeZoneIntOffset = localStorage.getItem("userTimezoneIntOffset");
                  this.globals.vTimeZone = localStorage.getItem("timeszone");
                  this.globals.vShortTimeZone = localStorage.getItem("userShortTzName");

                } else {
                  var offset = new Date().getTimezoneOffset();
                  var timezone = moment.tz.guess();
                  var timezoneabbr = moment.tz.zone(timezone)?.abbr(offset);
                  var date = new Date();
                  var timeOffset = moment(date).format('Z');
                  this.globals.vTimeZone = timezone;
                  this.globals.vShortTimeZone = timezoneabbr;
                  // this.globals.vTimeZoneIntOffset = "+5.5" ;
                }
                this.utilityService.getDefaultMeetingDate();
                this.utilityService.getDefaultMeetingTime();

              }
              if (this.meetingId != undefined) {
                this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": this.meetingId }) }, skipLocationChange: true, replaceUrl: false });
              } else if (this.currentUser.loginFlag == "1") {
                var reqJson = { "loginName": localStorage.loginName, "orgCode": localStorage.orgCode, "newPasswordFlag": "0" };
                this.userService.fetchPasswordDetails(reqJson).subscribe((data: any) => {
                  this.passwordPolicyMap = data?.body?.pwdPolicyMap
                  var forgotPasswordJson = {
                    "firstName": this.currentUser.firstName,
                    "loginName": this.currentUser.loginName,
                    "email": this.currentUser.email,
                    "pwdPolicyMap": this.passwordPolicyMap
                  }
                  this.router.navigate(['/forgotPassword'], { queryParams: { "userInfo": JSON.stringify({ "userInfo": forgotPasswordJson, "email": false }) }, skipLocationChange: true, replaceUrl: false });
                });
              } else {
                this.router.navigate(['/dashboard']);
              }


            } else {
              this.showValidator = true;
              this.spinner.hide();
              let emailLink = 'agora_support@chn.aithent.com'
              let path = '#'
              this.errorMessage = this.currentUser.errorMessage;
              if (this.errorMessage == "PASSWORDEXPIRED") {
                var reqJson = { "loginName": localStorage.loginName, "orgCode": localStorage.orgCode, "newPasswordFlag": "0" };
                this.userService.fetchPasswordDetails(reqJson).subscribe((data: any) => {
                  this.passwordPolicyMap = data?.body?.pwdPolicyMap
                  var changePassword = {
                    "loginName": this.f.userName.value,
                    "pwdPolicyMap": this.passwordPolicyMap
                  }
                  this.router.navigate(['/forgotPassword'], { queryParams: { "userInfo": JSON.stringify({ "userInfo": changePassword, "email": false, "errMsg": this.errorMessage }) }, skipLocationChange: true, replaceUrl: false })

                });

              }
            }
          },
          (error: string) => {
            this.error = error;
            this.spinner.hide();
            this.loading = false;
            this.showValidator = true
          });
    });
  }

  required = true;

  toggleHelpVideo() {
    // this.showHelpVideo = !this.showHelpVideo;
    this.router.navigate(["help"])
  }

  AnsQuesCount() {
    var answered = this.forgetPassword.controls['questionContainer'].value;
    var ansCount = 0;
    answered.forEach(function (val: any) {
      if (val.quesAnswer != null && val.quesAnswer.length != 0) {
        ansCount++;
      }

    })
    return ansCount;
  }

  onSubmitForgetPassword() {

    this.forgetPasswordSubmitted = true;
    if (this.forgetPassword.invalid) {
      this.forgetPasswordSubmitted = false;
    }
    var answered = this.forgetPassword.controls['questionContainer'].value;


    if (this.forgetPassword.controls['email'].value == "") {
      this.forgotPasswordJson = {
        "firstName": this.userDetails.firstName,
        "loginName": this.userDetails.loginName,
        "email": this.forgetPassword.controls['email'].value,
        "secQuesString": JSON.stringify(this.forgetPassword.controls['questionContainer'].value)
      }

    } else {
      this.forgotPasswordJson = {
        "firstName": this.userDetails.firstName,
        "loginName": this.userDetails.loginName,
        "email": this.forgetPassword.controls['email'].value,
        "secQuesValues": ""
      }
    }


    var ansCount = this.AnsQuesCount();

    if (this.forgetPassword.get('email')?.value != "" || (ansCount == answered.length)) {
      this.userService.forgotPasswordSecQues(this.forgotPasswordJson).subscribe((data: any) => {
        if (data.body.errorMessage == "") {
          if (data.body.email == "") {
            data.body.pwdPolicyMap = this.userDetails.pwdPolicyMap;
            this.router.navigate(['forgotPassword'], { queryParams: { "userInfo": JSON.stringify({ "userInfo": data.body }) }, skipLocationChange: true, replaceUrl: false })

          } else {
            this.loginForm.reset();
            this.showSignIn = true;
            this.showForgetPasswordDiv = false;
            this.showSecurityQuestions = false;
            this.notifier.show({
              type: 'success',
              message: 'Password will be sent to your email address shortly'
            });
            // this.router.navigate([''], { queryParams: { "userInfo": JSON.stringify( {"userInfo" : data.body , "email" : false }) }, skipLocationChange: true, replaceUrl: false })

            this.forgetPassword.reset();
          }

        } else {
          this.notifier.show({
            type: 'error',
            message: data.body.errorMessage
          });
        }

      });
    }
    else {
      this.notifier.show({
        type: 'error',
        message: 'Either the Security question has to be answered or the Email address has to be provided in order to reset the password.'
      });
    }
  }

  FieldValidation() {
    if (this.forgetPassword.get('email')?.value != "") {
      for (var index = 0; index < this.forgetPassword.get('questionContainer')?.value.length; index++) {
        var item = (<UntypedFormArray>this.forgetPassword.get('questionContainer')).at(index);
        item.get('quesCode')?.clearValidators();
        item.get('quesCode')?.updateValueAndValidity();
        item.get('quesAnswer')?.clearValidators();
        item.get('quesAnswer')?.updateValueAndValidity();
      }
    }
    else {
      for (var index = 0; index < this.forgetPassword.get('questionContainer')?.value.length; index++) {
        var item = (<UntypedFormArray>this.forgetPassword.get('questionContainer')).at(index);
        item.get('quesCode')?.setValidators([Validators.required]);
        item.get('quesCode')?.updateValueAndValidity();
        item.get('quesAnswer')?.setValidators([Validators.required]);
        item.get('quesAnswer')?.updateValueAndValidity();
      }
    }
    var answered = this.forgetPassword.controls['questionContainer'].value;
    if (this.AnsQuesCount() == answered.length) {
      this.forgetPassword.get('email')?.clearValidators();
      this.forgetPassword.get('email')?.updateValueAndValidity();
    }
    else {
      this.forgetPassword.get('email')?.setValidators([Validators.email]);
      this.forgetPassword.get('email')?.updateValueAndValidity();
    }
  }

  //fetch rolelist and assign to global value
  fetchRoleList() {
    return new Promise((resolve) => {

      this.attendeeService.getRoleList().subscribe((data: any) => {
        this.globals.userRoleList = data;

        resolve(this.globals.userRoleList);
      });

    })
  }
  //fetch task status 
  fetchTaskStatus() {
    //if(this.globals.globaltaskStatusList!=null && this.globals.globaltaskStatusList!=undefined){
    return new Promise((resolve) => {
      this.meetingService.getTaskStatus().subscribe((taskStatudList: any) => {
        this.taskStatusList = taskStatudList.body;
        this.globals.globaltaskStatusList = taskStatudList.body;
        resolve(this.globals.globaltaskStatusList);
      })

    });
    //}
  }

  fetchProjectList() {
    return new Promise((resolve) => {
      this.loginService.getTuleapProjectList().subscribe((data: any) => {

        this.globals.globalProjectList = data.body;
        resolve(this.globals.globalProjectList);
      });

    })
  }

  fetchSpeechEnable() {
    return new Promise((resolve) => {

      this.userService.getUserDetails(localStorage.userId).subscribe((data: any) => {
        resolve(data.body);
      });

    })
  }

  //trigger security question for forgot password
  triggerSecurityQuestions() {
    localStorage.clear();
    this.questions = [];
    var reqJson1 = { "loginName": this.forgetPassword.controls['userName'].value, "orgCode": "free_orgcode", "newPasswordFlag": "0" };

    this.userService.fetchPasswordDetails(reqJson1).subscribe((data: any) => {
      this.userDetails = data.body;



      if (data.body.errorMessage == null || data.body.errorMessage == undefined) {

        if (!this.m.userName.errors && data.body.answeredSecQuesList.length != 0) {
          this.showSecurityQuestions = true
        } else {
          this.showSecurityQuestions = false

        }
        for (let i = 1; i < data.body.noOfSecQuesAns; i++) {
          let fg = this.createEmpFormGroup();
          this.securityQuestions.push(fg);

        }
        var randomArray = new Array;
        var rand;
        var totalQues = 0;
        while (totalQues < data.body.noOfSecQuesAns) {
          rand = Math.floor(Math.random() * data.body.noOfSecQuesConf);

          if (randomArray.indexOf(rand) == -1) {
            randomArray.push(rand);
            totalQues++;
          }
        }

        var answeredList = data.body.answeredSecQuesList;
        var formArray = new UntypedFormArray([])
        for (let i = 0; i < randomArray.length; i++) {
          var singleQues = answeredList[randomArray[i]];
          var ques: any;

          if (singleQues != null || singleQues != undefined) {
            formArray.push(this.formBuilder.group({
              "quesCode": [singleQues[1], [Validators.required]],
              "question": [singleQues[2]],
              "quesAnswer": ['', [Validators.required]]
            }))
            ques = {
              "quesCode": singleQues[1],
              "question": singleQues[2],
              "quesAnswer": ""
            }
            this.questions.push(ques);
          }

          this.forgetPassword.setControl("questionContainer", formArray);

        }
      } else {

        this.notifier.show({
          type: 'error',
          message: data.body.errorMessage
        });
      }
    });

  }
  forgetPasswordSubmit() {


    this.forgotPasswordJson = {

      "firstName": this.userDetails.firstName,
      "loginName": this.userDetails.loginName,
      "emailid": this.forgetPassword.controls['email'].value,
      "secQuesValues": JSON.stringify(this.forgetPassword.controls['questionContainer'].value)
    }


    //  this.router.navigate(['forgotPassword'])
  }
  checkGroupNameExist() {

    this.userService.checkCompanyExists(this.groupUserRegForm.controls['companyName'].value).subscribe((data: any) => {
      this.companyExist = data.body;

    });

  }

  selectToCheck(option: any) {

    this.groupUserRegForm.controls['companyName'].setValue(option[0]);
    this.groupUserRegForm.controls['orgCode'].setValue(option[1]);
    this.userService.fetchAdminDetails(option[1]).subscribe((data: any) => {

      this.adminDetails = data.body.adminDetail
      if (this.adminDetails) {
        this.groupUserRegForm.controls['adminUserId'].setValue(this.adminDetails.adminUserId);
        this.groupUserRegForm.controls['adminLoginName'].setValue(this.adminDetails.adminLoginName);
        this.groupUserRegForm.controls['adminFullName'].setValue(this.adminDetails.adminFullName);
        this.groupUserRegForm.controls['adminEmail'].setValue(this.adminDetails.adminEmail);
      }
      //  this.groupUserRegForm.controls['isAdmin'].setValue('');


    });
  }

  createNewGroupUser() {

    this.isSubmitted = false;
    if (this.groupUserRegForm.invalid) {
      this.isSubmitted = true;
      return;
    }
    this.validate = false;
    this.spinner.show();
    this.groupUserRegForm.controls['timeszone'].setValue(this.timezone);
    this.groupUserRegForm.controls['jobType'].setValue('C');

    this.userService.saveUser(this.groupUserRegForm.value).subscribe((data: any) => {
      var resp = data;
      if (resp.body.errorMessage == null || resp.body.errorMessage == undefined) {
        this.notifier.show({
          type: 'success',
          message: 'Registration is successful. Thank you for registering with Agora. Please check your email.'
        });
        this.spinner.hide();
        this.showSignInDiv(true);
      } else {
        this.notifier.show({
          type: 'error',
          message: resp.body.errorMessage
        });
        this.spinner.hide();
        this.groupUserRegForm.reset();
        //this.showSignInDiv(true);
      }
    });
  }

  refreshTokenTimeout: any;

  startRefreshTokenTimer(token: any) {
    // parse json object from base64 encoded jwt token
    const jwtToken = JSON.parse(atob(token.split('.')[1]));
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = expires.getTime() - Date.now() - (2 * 60 * 1000);
    this.refreshTokenTimeout = setTimeout(() =>
      this.generateRefreshedToken(), timeout);
  }

  stopRefreshTokenTimer() {
    clearTimeout(this.refreshTokenTimeout);
  }

  generateRefreshedToken() {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      })
    };

    httpOptions.headers = httpOptions.headers.set('userName', `${localStorage.getItem("encLoginName")}`);
    httpOptions.headers = httpOptions.headers.set('Authorization', `Bearer ${localStorage.getItem("token")}`);
    let obj = {
      userName: localStorage.getItem('loginName')
    }
    this.loginService.getRefreshTokenValue(obj, httpOptions).subscribe((data: any) => {
      localStorage.setItem("token", data.jwtToken);
      const currentUser = this.authenticationService.currentUserValue;
      currentUser.jwtToken = data.jwtToken;
      localStorage.setItem('currentUser', JSON.stringify(currentUser));
    });
  }
  hideSecurityQuestions(bool: any) {
    this.showSecurityQuestions = bool
  }

  fetchDocList() {


    return new Promise((resolve) => {
      this.meetingService.getDocList().subscribe((docMeetTypeList: any) => {
        this.globals.globalDocMeetTypeList = docMeetTypeList;
        resolve(this.globals.globalDocMeetTypeList);
      })
    });
  }
  encryptWithPublicKey(valueToEncrypt: string): string {

    const publicKeyObj = Forge.pki.publicKeyFromPem(`-----BEGIN PUBLIC KEY-----\n${this.publicKey}\n-----END PUBLIC KEY-----`);
    const encryptedData = publicKeyObj.encrypt(valueToEncrypt);
    return forge.util.encode64(encryptedData);
  }

}
